module.exports = __webpack_public_path__ + "static/media/arrow-right.e96d8158.svg";